import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminService } from 'src/app/admin-pages/admin.service';
import { LayoutService } from 'src/app/layout/layout.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-servicenear-profile',
  templateUrl: './servicenear-profile.component.html',
  styleUrls: ['./servicenear-profile.component.scss']
})
export class ServicenearProfileComponent implements OnInit {

  UserInfo!: FormGroup;
  profileDetails: any = {};
  isUserInfoEdit: boolean = false;
  isAdminUser: boolean = false;
  userDetails: any = {};
  isLoading: boolean = true;

  // for tost msg
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean;
  branchInfo: any;

  constructor(
    public adminService: AdminService,
    public configService: ConfigService,
    private fb: FormBuilder,
    public layoutService: LayoutService,
  ) { }

  ngOnInit(): void {
    this.populateToolbarData();
    this.userDetails = this.adminService.getLoginDetails();
    if (this.userDetails.UserType === "admin") {
      this.isAdminUser = true;
    }
    this.getUserDetails();
    this.initUserInfoForm();
  }


  private getUserDetails() {
    this.isLoading = true;
    this.adminService.getUserProfile(this.userDetails.UserID).subscribe(
      (res: any) => {
        if (res.Result == 'Success') {
          this.profileDetails = res.ResponseData;
          try {
            this.profileDetails.SocialMediaLinks = JSON.parse(
              this.profileDetails.SocialMediaLinks || '{}'
            );
          } catch {
            this.profileDetails.SocialMediaLinks = {};
          }
          this.UserInfo.patchValue({
            FirstName: this.profileDetails?.FirstName,
            LastName: this.profileDetails?.LastName,
            Email: this.profileDetails?.Email,
            MobileNo: this.profileDetails?.MobileNo,
            District: this.profileDetails?.District,
            State: this.profileDetails?.State,
            Country: this.profileDetails?.Country,
            Landmark: this.profileDetails?.Landmark,
            Pincode: this.profileDetails?.Pincode,
          })
        }
        this.isLoading = false;
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
      }
    );
  }

  public initUserInfoForm() {
    this.UserInfo = this.fb.group({
      FirstName: ["", [Validators.required]],
      LastName: [""],
      Email: [""],
      MobileNo: [""],
      District: [""],
      State: [""],
      Country: [""],
      landmark: [""],
      Pincode: [""],
    });

    this.UserInfo.disable();
  }

  updateStaffUser() {
    this.isLoading= true;
    let params = {
      id: this.userDetails.UserID,
      firstName: this.UserInfo.get('FirstName')?.value,
      lastName: this.UserInfo.get('LastName')?.value,
      email: this.UserInfo.get('Email')?.value,
      mobileNo: this.UserInfo.get('MobileNo')?.value,
      District: this.UserInfo.get('District')?.value,
      State: this.UserInfo.get('State')?.value,
      Country: this.UserInfo.get('Country')?.value,
      landmark: this.UserInfo.get('landmark')?.value,
      Pincode: this.UserInfo.get('Pincode')?.value,
    }

    this.adminService.updateStaffUser(params).subscribe(
      (res: any) => {
        if (res.Result == 'Success') {
          this.getUserDetails();
          let adminDetails = JSON.parse(localStorage.getItem('admin_Details') || '{}');
          const name = `${params.firstName || ''} ${params.lastName || ''}`.trim(); 
          if (adminDetails) {
            adminDetails.Name = name;
            localStorage.setItem('admin_Details', JSON.stringify(adminDetails));
          }
           this.notify(true, 'Profile details updated successfully.');
        }else{
          this.notify(false, 'Failed to update. Please try again.');
        }
        this.isLoading= false;
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notify(false, 'Failed to update. Please try again.');
      }
    );

  }

  public editbtnClicked() {
    this.isUserInfoEdit = !this.isUserInfoEdit;
    //patch
    if(this.isUserInfoEdit){
      this.UserInfo.enable();
    }else{
      this.UserInfo.disable();
    }

    this.UserInfo.patchValue({
      FirstName: this.profileDetails?.FirstName,
      LastName: this.profileDetails?.LastName,
      Email: this.profileDetails?.Email,
      MobileNo: this.profileDetails?.MobileNo,
      District: this.profileDetails?.District,
      State: this.profileDetails?.State,
      Country: this.profileDetails?.Country,
      Landmark: this.profileDetails?.Landmark,
      Pincode: this.profileDetails?.Pincode,
    })
  }
  
  public submitUserInfoEdit() {
    this.isUserInfoEdit = !this.isUserInfoEdit;
    this.UserInfo.disable();
    //call update api
    this.updateStaffUser()
  }

  private notify(status: boolean, msg: string) {
    this.showToast = true;
    this.isSuccess = status;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showToast = false;
    }, 3000);
  }

  get fullAddress(): string {
    const details = this.profileDetails;

    if (!details) return '';

    const parts = [
      details.District,
      details.State,
      details.Country,
      details.Landmark,
      details.Pincode
    ];

    // Remove undefined, null, empty strings
    return parts.filter(p => p && p !== '').join(', ');
  }

  private populateToolbarData() {
    this.layoutService.setToolbar({
      title: 'Profile',
    });

    this.layoutService.setNavbarButtons([]);
  }
}
